import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import KeywordQuery from '../../../components/Keyword/Query'
import { fetchBadWords, setErrorBoundaryError } from '../../../actions'

const setNotFound = (message = '查無關鍵字') => {
  return setErrorBoundaryError({ message })
}

const mapStateToProps = (state, ownProps) => {
  return {
    page: state.page
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = {
    fetchBadWords,
    setNotFound
  }

  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

KeywordQuery.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  const isEmptyDisplayName = _.isEmpty(_.get(req, 'query.displayName'))
  try {
    const tasks = isEmptyDisplayName
      ? [store.dispatch(setNotFound())]
      : []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const MappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(KeywordQuery)

export default MappedComponent
